import { b64EncodeUnicode } from "../b64encode";
import { getOverwrite, OverwriteType } from "../middleware";
import request from "../request";
import { AnyObj } from "./types";

export interface HookInfo {
  fn?: string;
  // 优先级
  priority?: number;
}

export interface EcodeRegHooksInfo {
  [key: string]: {
    [key: string]: {
      [key: string]: { hooks: HookInfo[], appIds: string[] };
    }
  }
}

const hooksMap: AnyObj = {
  regOvComponent: 'ovComponent',
  regOvProps: 'ovProps',
}

/* 从中间件中获取注册钩子 */
export function getMiddlewareRegistry (callback?: ((app: string, name: string, fnName: string) => string[])) {
  // 获取当前 middlware 中间件注册过的组件复写
  const overwrites = getOverwrite() as OverwriteType;
  return Object.keys(overwrites).reduce((targetApps, app) => {
    const appHooks = overwrites[app] || {};
    targetApps[app] = Object.keys(appHooks).reduce((targetComponents, name) => {
      const componentHooks = appHooks[name] || {};
      targetComponents[name] = Object.keys(componentHooks).reduce((targetApi, fnName) => {
        const hooks = componentHooks[fnName] || [];
        targetApi[fnName] = {
          hooks: hooks.map(hook => {
            return ({
              fn: b64EncodeUnicode(hook.fn.toString().slice(0, 100)), // 注册函数转成字符串，并截取前100个字符
              priority: hook.priority,
            });
          }),
          appIds: callback?.(app, name, fnName) || [],
        };
        return targetApi;
      }, {} as EcodeRegHooksInfo[string][string]);
      return targetComponents;
    }, {} as EcodeRegHooksInfo[string]);
    return targetApps;
  }, {} as EcodeRegHooksInfo);
}

/* 从 ecode 获取钩子注册 */
export function getHookRegistryFromEcode () {
  return new Promise((resolve, reject) => {
    // 获取生效的 appId，并通过接口获取复写的组件
    // 获取当前加载的 appIds
    var appIds = Object.keys(window.weappEcodesdk?.jsonp || {}).filter(key => /\d{18}/.test(key));
    if (!appIds.length) return;
    if (!window.ETEAMSID) return; // 登录前，无法请求接口
    // 根据appIds 查询应用中组件复写的情况
    request({
      url: '/api/ecode/monitor/list',
      method: 'POST',
      data: { appIds: appIds.join() },
    }).then(res => {
      let registedAppIds: EcodeRegHooksInfo = {};
      if (res?.data) {
        registedAppIds = Object.keys(res.data).reduce((target, appId) => {
          const registedHooks = res.data[appId];
          if (Array.isArray(registedHooks) && registedHooks.length) {
            registedHooks.forEach((hook) => {
              const { libName, comName, ecodeSDK } = hook || {};
              const hookName = hooksMap[ecodeSDK] || ecodeSDK;
              target[libName] = target[libName] || {};
              target[libName][comName] = target[libName][comName] || {};
              target[libName][comName][hookName] = target[libName][comName][hookName] || {};
              const appIds = target[libName][comName][hookName].appIds || [];
              if (!appIds.includes(appId)) {
                appIds.push(appId); // 防止 appIds 重复
              }
              target[libName][comName][hookName].appIds = appIds;
            });
          }
          return target;
        }, {} as EcodeRegHooksInfo);
      }
      // 将 appIds 加到中间件复写的钩子数据里
      const overwrites = getMiddlewareRegistry((app, name, fnName) => {
        if (registedAppIds[app] && registedAppIds[app][name] && registedAppIds[app][name][fnName]) {
          return registedAppIds[app][name][fnName].appIds || [];
        }
        return [];
      });
      // overwrites 转字符串上报
      resolve({ regHooks: JSON.stringify(overwrites) });
    }).catch(err => {
      // 无法获取 appIds 直接上报复写信息
      resolve({ regHooks: JSON.stringify(getMiddlewareRegistry()) });
    });
  });
}

